// extracted by mini-css-extract-plugin
export default {"avatar":"Map_avatar__WsEXn","vehicle":"Map_vehicle__d5bgA"};